import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AbstractMedia } from 'types/AbstractMedia';

import { Modal, Button, Icon } from 'components/ui';
import { ButtonType } from 'components/ui/Button';
import { downloadURL } from 'utils/downloadUtils';

type FileDownloadModalProps = {
  open?: boolean,
  files: Array<AbstractMedia>,
  onClose?: (open: boolean) => void,
  onDownload?: (file: AbstractMedia) => unknown,
  title?: React.ReactNode,
};

const defaultTitle = (
  <FormattedMessage id="page.finalInstructions.downloadDocuments" defaultMessage="Download documents" tagName="h3" />
);

const FileDownloadModal: React.FC<FileDownloadModalProps> = ({ files, open, onClose, onDownload, title = defaultTitle }) => {
  const handleDownload = React.useCallback((file: AbstractMedia) => {
    if (onDownload) {
      return () => onDownload(file);
    }

    return () => downloadURL(file.path, file.filename);
  }, [onDownload]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="modal-large"
      title={title}
    >
      <div className="flex flex-col gap-4 kiosk:gap-8 w-full">
        {files.length > 0 && (
          <div className="flex flex-col gap-2 kiosk:gap-4 items-center p-s w-full rounded-button-list bg-card-bg">
            {files.map((file) => (
              <Button
                key={file.id}
                type={ButtonType.WHITE}
                testId={`file-${file.id}`}
                onClick={handleDownload(file)}
                className="flex items-center p-3xs! pl-s! justify-between w-full"
              >
                <span className="overflow-hidden text-ellipsis text-nowrap">{file.filename}</span>
                <div className="inline-block leading-none! text-button-s! p-3 kiosk:p-6 rounded-full bg-btn-primary-icon-bg ml-2">
                  <Icon className="fb-icon--download leading-none! text-button-s!" />
                </div>
              </Button>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default FileDownloadModal;
